import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import moment from 'moment';

import { adaptDateToLocalTimezone } from '../../../utils/converters/dateConverters';
import Icon from '../../Icon';

import styles from './styles.styl';

export const TimeShowIml = ({ timestamp, hideIcon }) => {
  const timeText = useMemo(() => {
    const adapted = adaptDateToLocalTimezone(timestamp);
    const time = moment(adapted);

    const getFormat = () => {
      if (time.isSame(new Date(), 'day')) {
        return 'hh:mm a';
      }
      if (time.isSame(new Date(), 'week')) {
        return 'hh:mm a dddd';
      }
      if (time.isSame(new Date(), 'year')) {
        return 'MMM D, hh:mm A';
      }
      return 'MMM D Y, hh:mm A';
    };

    return time.format(getFormat());
  }, [timestamp]);

  return (
    <div styleName="root">
      <If condition={!hideIcon}>
        <Icon name="icon-time-status" size={12} />
      </If>
      <span styleName="text">{timeText}</span>
    </div>
  );
};

export const TimeShow = compose(CSSModules(styles, { allowMultiple: true }))(
  TimeShowIml,
);

const propTypes = {
  timestamp: PropTypes.string.isRequired,
  hideIcon: PropTypes.bool,
};

TimeShowIml.propTypes = propTypes;
TimeShow.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/common/TimeShow/index.jsx